import { render, staticRenderFns } from "./PgFormFilter.vue?vue&type=template&id=5889c363&"
import script from "./PgFormFilter.vue?vue&type=script&lang=js&"
export * from "./PgFormFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PgFormFilter.vue"
export default component.exports